import { useState } from "react";
import {
  Box,
  DialogContent,
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";

import { NetworkIcon, PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { can } from "authorization/authorization.util";
import { ZonePermissionEnum } from "authorization/types";
import { DynamicButton } from "components/DynamicButton/DynamicButton";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { IZone } from "interfaces/zone.interface";

import { ZoneMenu } from "./ZoneMenu";

type ZoneDrawerProps = {
  zones: IZone[];
};

export const ZoneDrawer = ({ zones }: ZoneDrawerProps) => {
  const { t } = useTranslation();
  const { permissions } = useAuthenticatedUser();

  const canCreateZone = can(permissions, ZonePermissionEnum["zone.create"]);

  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: { xs: "initial", md: "none" },
        paddingTop: 2,
        paddingRight: 1,
      }}
    >
      <IconButton onClick={() => setOpen(true)} aria-label={t("Zones")}>
        <NetworkIcon />
      </IconButton>
      <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
        <Box
          display={"flex"}
          paddingInline={2}
          paddingBlock={1}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant={"headingLargeRegular"}>{t("Zones")}</Typography>
          {canCreateZone && (
            <DynamicButton
              href={"/administration/create-zone"}
              startIcon={<PlusIcon />}
              variant={"text"}
            >
              {t("create_zone")}
            </DynamicButton>
          )}
        </Box>
        <DialogContent dividers sx={{ width: "400px", maxWidth: "90vw" }}>
          <ZoneMenu zones={zones} />
        </DialogContent>
      </Drawer>
    </Box>
  );
};
